export default "__VITE_ASSET__BKMe47Q4__"